<template>
  <div class="osahan-home-page">
    <!-- Filters -->
    <div class="container">
      <div class="d-flex align-items-center justify-content-between my-3">
        <h3 class="mt-4 ml-3 mb-4">Catégories</h3>
      </div>
      <div class="cat-slider">
        <glide-component
          :settings="glideBasicOption"
          :active="selected"
          @setselected="changeSelectedSection"
          id="categories"
        >
          <div
            class="cat-item px-1 py-3 glide__slide"
            v-for="(section, index) in listSections"
            @click="selected = index"
            :key="`section_${index}`"
          >
            <a
              :class="
                `bg-white d-block p-2 text-center shadow-sm categorie-swigi ${
                  selected == index ? 'active-categorie' : ''
                }`
              "
              href="#"
            >
              <img
                alt="#"
                :src="
                  `${
                    section.image
                      ? 'https://space.monresto.menu/uploads/categories/' +
                        section.image
                      : 'https://space.monresto.menu/theme9/img/icons/Fries.png'
                  }`
                "
                class="img-fluid mb-2"
              />
              <p class="m-0 small">
                {{ section.title }}
              </p>
            </a>
          </div>
        </glide-component>
      </div>
    </div>
    <div class="container sous-container">
      <div class="d-flex align-items-center justify-content-between my-3">
        <h3 class="mt-3">Sous catégories</h3>
      </div>
      <div
        class="cat-slider"
        v-if="newItem[0].sections[selected].show_subCategories"
      >
        <glide-component
          :settings="glideBasicOptionSous"
          :active="sub_selected"
          @setsubselected="changeSelectedSubSection"
          v-if="flagSubSections > 0"
          id="subCategories"
        >
          <div
            class="cat-item px-1 py-3 glide__slide"
            v-for="(subSection, indexSubCategorie) in listSections[selected]
              .sub_sections"
            @click="sub_selected = indexSubCategorie"
            :key="`subSection${indexSubCategorie}`"
          >
            <a
              :class="
                `bg-white d-block p-2 text-center shadow-sm categorie-swigi ${
                  sub_selected == indexSubCategorie ? 'active-categorie' : ''
                }`
              "
              href="#"
            >
              <img
                alt="#"
                src="https://space.monresto.menu/theme9/img/icons/Fries.png"
                class="img-fluid mb-2"
              />
              <p class="m-0 small">
                {{ subSection.title }}
              </p>
            </a>
          </div>
        </glide-component>
      </div>
    </div>
    <div class="container">
      <div class="d-flex align-items-center justify-content-between my-3">
        <h3 class="mt-4 ml-3 mb-4">Articles</h3>
      </div>
      <div
        class="most_popular"
        v-if="showSub(listSections[selected].sub_sections[sub_selected])"
      >
        <div class="row d-flex justify-content-center align-items-center">
          <div
            class="col-md-3 pb-3"
            v-for="(item, indiceItem) in listSections[selected].sub_sections[
              sub_selected
            ].items"
            :key="`Item${indiceItem}`"
          >
            <div
              class="list-card bg-white h-100  overflow-hidden position-relative shadow-sm"
            >
              <div class="list-card-image">
                <div class="star position-absolute">
                  <span class="badge badge-success">
                    <span>
                      {{ currentCurrency.symbol }}
                    </span>
                    <span>{{ item.price }} </span>
                  </span>
                </div>
                <div class="favourite-heart text-danger position-absolute">
                  <a href="#"><i class="feather-heart"></i></a>
                </div>
                <div class="member-plan position-absolute">
                  <div class="tags">
                    <!-- <img
                      src="/uploads/tags/{{tag.image}}"
                      alt="{{tag.title}}"
                    /> -->
                  </div>
                </div>
                <a href="#">
                  <img
                    alt="#"
                    :src="
                      `${
                        item.image
                          ? 'https://space.monresto.menu/uploads/menus-items/' +
                            item.image
                          : 'https://space.monresto.menu/assets/img/detail-small-5.jpg'
                      }`
                    "
                    class="img-fluid item-img w-100 custom-img"
                  />
                </a>
              </div>
              <div class="p-3 position-relative text-left">
                <div class="list-card-body">
                  <h6 class="mb-1">
                    <a href="#" class="text-black">{{ item.title }} </a>
                  </h6>
                  <p class="text-gray mb-1 small">
                    {{ item.observation }}
                  </p>
                  <ul class="rating-stars list-unstyled">
                    <span
                      class="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"
                      ><i class="feather-clock"></i>
                      {{ item.optionsItem ? item.optionsItem.duree : 0 }}
                      min</span
                    ><span class="float-right text-black-50">
                      <i class="feather-clock"></i>
                      {{ item.optionsItem ? item.optionsItem.calories : 0 }}
                      KCAL</span
                    >
                  </ul>
                  <p></p>
                </div>
                <div class="list-card-badge">
                  <span class="badge badge-danger">{{
                    listSections[selected].title +
                      `${
                        listSections[selected].sub_sections[sub_selected]
                          .title != "null-sub-sections"
                          ? "-" +
                            listSections[selected].sub_sections[sub_selected]
                              .title
                          : ""
                      }`
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- offer sectio slider -->
  </div>
</template>

<script>
import GlideComponent from "../plugins/GlideComponent.vue";

export default {
  components: {
    "glide-component": GlideComponent,
  },
  props: [
    "smaler",
    "newItem",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "handleChangeShowSub",
    "currentCurrency",
    "currentLang",
  ],
  data() {
    return {
      glideBasicOption: {
        gap: 5,
        perView: 4,
        focusAt: "center",
        peek: 50,
        type: "carousel",
        hideNav: true,
        breakpoints: {
          600: {
            perView: 1,
          },
          1400: {
            perView: 2,
          },
        },
      },
      glideBasicOptionSous: {
        hideNav: true,

        type: "carousel",
        perView: 2,
        focusAt: "center",
        breakpoints: {
          800: {
            perView: 2,
          },
          480: {
            perView: 1,
          },
        },
      },
      selected: 0,
      sub_selected: 0,
      collapsedSubSection: [],
      collapsedArrayVar: [],
      collapsedSection: [],
    };
  },
  computed: {
    flagSubSections: function() {
      return this.listSections[this.selected].sub_sections.length;
    },
  },
  watch: {
    selected(newval) {
      // alert("HEEEY");
      console.log("%c HEEEEEEEY ", "color:orange; font-size:25px;");
      console.log(this.listSections[this.selected].sub_sections);
      console.log(this.flagSubSections);
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    changeSelectedSection(indexParam) {
      // alert(indexParam + " FROM CHANGE EMITED");
      this.selected = indexParam;
    },
    changeSelectedSubSection(indexParam) {
      // alert(indexParam + " FROM CHANGE EMITED");
      this.sub_selected = indexParam;
    },

    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    vIfcollapsedSection(indexSection) {
      indexSection = `cat${indexSection}`;
      let item = this.collapsedSection.find((item) => item == indexSection);
      if (item) {
        return true;
      } else {
        return false;
      }
    },

    funcCollapsedSection(indexSection) {
      indexSection = `cat${indexSection}`;

      if (this.collapsedSection.includes(indexSection)) {
        this.collapsedSection.splice(
          this.collapsedSection.indexOf(indexSection),
          1
        );
      } else {
        this.collapsedSection.push(indexSection);
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    selectSectionHandler(index) {
      this.selected = index;
      if (this.collapsedSections.includes(index)) {
        this.collapsedSections.splice(this.collapsedSections.indexOf(index), 1);
      } else {
        this.collapsedSections.push(index);
      }
    },

    toggleCollapsed(index) {
      if (this.collapsedSubSection.includes(index)) {
        this.collapsedSubSection.splice(
          this.collapsedSubSection.indexOf(index)
        );
      } else {
        this.collapsedSubSection.push(index);
      }
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      if (!subSection) {
        return false;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 10%) !important;
}
.sous-container {
  width: 90%;
}
.active-categorie {
  box-shadow: 0 0.125rem 0.6rem rgb(0 0 0 / 15%) !important;
  color: cadetblue;
  font-weight: 700;
}
/*
.active-sous-categorie {
  background-color: cadetblue !important;
} */

.glide__slide {
  filter: blur(1.5px);
  opacity: 0.7;
  transition: 0.3s linear;
}

.glide__slide--active {
  opacity: 1;
  filter: none;
  transform: scale(1.1);
  z-index: 999;
}
.glide__slides {
  overflow: visible;
}
.categorie-swigi {
  width: 100%;
}
.swigi-new-cat {
  padding: 0.6em;
  font-size: 11px;
  font-weight: 700;
}
.artice-edit {
  flex: 1;
}
</style>
